<template>
    <div class="main-container">

       <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />

        <section class="main-content-section">
            <tl-tabs :tabs="tabs">
                <tl-tab>
                    <loan-calculation></loan-calculation>
                </tl-tab>
                <tl-tab>
                    <loan-list></loan-list>
                </tl-tab>
            </tl-tabs>
        </section>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from "vuex";
    import loanCalculation from "./loanCalculation.vue";
    import loanList from "./loanList.vue";

    export default {
        name: "Loans",
        computed: {
            ...mapState({}),
            ...mapGetters({
                orgid: "onboard/organization/orgid"
            }),
            le_id() {
                return "1580822c-764b-11e9-8f9e-2a86e4085a59";
            }
        },

        components: {
            loanList,
            loanCalculation
        },
        data() {
            return {
                breadcrumbList:[
                    {
                        name: "Organisation",
                        url: `/dashboard/${this.$route.params.entity_index}/organisation`
                    },
                    {
                        name: "Utilities",
                        url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
                    },
                    {
                        name: "Loan",
                        url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/loans`
                    }
                ],
                tabs: [
                    {
                        header: "Loan Calculation"
                    },
                    {
                        header: "Loan List"
                    }
                ]
            };
        },

        mounted() {
            //console.log("Mounted Loans.vue component");
        },

        methods: {
            ...mapActions({}),

            routeToMainStep() {
                this.$router.push({
                    path: `/dashboard/${this.$route.params.entity_index}/organisation`
                });
            },
            routeToSubStep() {
                this.$router.push({
                    path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
</style>